import { configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Import the root reducer

import rootReducer from './combined-reducers';

// Middleware: Redux Persist Config

const persistConfig = {
  // Root

  key: 'root',
  version: 1,

  // Storage Method (React Native)

  storage: storage,

  // Whitelist (Save Specific Reducers)

  whitelist: ['auth', 'forms'],

  // Blacklist (Don't Save Specific Reducers)

  blacklist: ['addresses', 'accounts', 'jobs', 'pep', 'fatca', 'references', 'clients', 'relations', 'lists', 'options', 'calendar', 'otp'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

let persistor = persistStore(store);

export {store, persistor};
